var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { localized, msg } from "@lit/localize";
import { getStatusColor } from "../../utils/color";
let NodeExecutionLogModal = class NodeExecutionLogModal extends LitElement {
    _closeModal() {
        const modal = this.shadowRoot?.querySelector("basic-modal");
        modal.handleClose();
    }
    render() {
        return html `
                <basic-modal ?open=${true}>
                    <div class="header">
                        <div style="display: flex; flex-direction: column; align-items: flex-start; flex: 1;">
                            <h2>${this.node.name} - ${msg("Execution Log")}</h2>
                            </div>
                            <div style="display: flex; align-items: center; gap: 1rem;">
                            <basic-status
                                class="status"
                                .status=${this.nodeExecution?.status.toUpperCase()}
                                .variant=${getStatusColor(this.nodeExecution?.status)}
                            ></basic-status>
                        </div>
                    </div>
                    <p><strong>${msg("Started at:")}</strong> ${this.nodeExecution?.started_at ? new Date(this.nodeExecution.started_at).toLocaleString() : ' - '}</p>
                    <p><strong>${msg("Ended at:")}</strong> ${this.nodeExecution?.finished_at ? new Date(this.nodeExecution.finished_at).toLocaleString() : ' - '}</p>
                    <div class="content">
                        <pre>${this.nodeExecution?.message}</pre>
                    </div>
                    <p><strong>${msg("Output Data:")}</strong></p>
                    <json-displayer .data=${this.nodeExecution?.output_data ?? null}></json-displayer>
                    <simple-button .label="${msg("Close")}" variant="secondary" class="footer" @button-click=${this._closeModal}>
                </basic-modal>
            `;
    }
};
NodeExecutionLogModal.styles = css `
            :host {
                display: block;
            }
            basic-modal::part(dialog) {
                min-width: 420px;
                max-width: 600px;
                padding: 0;
            }
            .header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 1rem 1.2rem 0.5rem 1.2rem;
            }
            .header h2 {
                margin: 0;
                font-size: 1.1rem;
                font-weight: 600;
            }
            .header .status {
                margin-left: 1rem;
            }
            .content {
                padding: 1rem 1.2rem;
                font-size: 1rem;
                max-height: 320px;
                overflow-y: auto;
                background-color: #f0f0f0;
                border-radius: 8px;
                margin-bottom: 1rem;
            }
            pre {
                margin: 0;
                font-family: 'Fira Mono', 'Consolas', monospace;
                font-size: 0.98rem;
                padding: 0.6rem;
                white-space: pre-wrap;
                word-break: break-word;
            }
            .footer {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                padding: 0.6rem 1.2rem 1rem 1.2rem;
            }
            basic-button[variant="ghost"] {
                min-width: 80px;
            }
            json-displayer {
                max-height: 300px;
                max-width: 80vw;
                overflow: auto;
                display: block;
            }
        `;
__decorate([
    property({ type: Object })
], NodeExecutionLogModal.prototype, "node", void 0);
__decorate([
    property({ type: Object })
], NodeExecutionLogModal.prototype, "nodeExecution", void 0);
NodeExecutionLogModal = __decorate([
    localized(),
    customElement("node-execution-log-modal")
], NodeExecutionLogModal);
export { NodeExecutionLogModal };
//# sourceMappingURL=NodeExecutionLogModal.js.map